import { rejectionReasonsSlice } from "./rejectionReasonsSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as fields from "../../pages/RejectionReasonsData/edit/constants";

const { actions } = rejectionReasonsSlice;

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/activity/rejectionreasons'

// CRUD
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
